import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FaHome, FaUserAlt, FaTools, FaMoneyBillWave } from 'react-icons/fa';
import './DashboardStats.scss';

const DashboardStats = () => {
  const stats = [
    {
      title: 'Properties',
      value: '124',
      icon: <FaHome />,
      color: '#4e73df'
    },
    {
      title: 'Users',
      value: '543',
      icon: <FaUserAlt />,
      color: '#1cc88a'
    },
    {
      title: 'Maintenance',
      value: '13',
      icon: <FaTools />,
      color: '#f6c23e'
    },
    {
      title: 'Revenue',
      value: '$50,240',
      icon: <FaMoneyBillWave />,
      color: '#36b9cc'
    }
  ];

  return (
    <Row>
      {stats.map((stat, index) => (
        <Col md={3} key={index}>
          <Card className="stat-card mb-4">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="stat-title text-uppercase">{stat.title}</div>
                  <div className="stat-value">{stat.value}</div>
                </div>
                <div className="stat-icon" style={{ color: stat.color }}>
                  {stat.icon}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardStats;
